import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { TourApiService } from '../services/tour-api.service';
import { TourService } from '../services/tour.service';
import { Scene } from '../model/scene';
import { ModalService } from '../services/modal.service';
import { EnumAware } from '../decorators/enum-aware.decorator';
import { WishlistService } from '../services/wishlist.service';
import { Subscription } from 'rxjs/Subscription';
import { TrackingService } from '../services/tracking.service';
import { SurveyApiService} from '../services/survey-api.service';
import { OptionGroup} from '../model/option-group';
import {Ad} from '../model/ad';
import {OptionDetailService} from '../services/option-detail.service';

@Component({
  selector: 'gt-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.css'],
  animations: [
    trigger('visibilityChanged', [
      state('true' , style({ opacity: 1 })),
      state('false', style({ opacity: 0 })),
      transition('* => *', animate('1s'))
    ])
  ]
})
@EnumAware
export class TourComponent implements OnInit, OnDestroy {
  currentScene: Scene;
  modelName: string;
  modelRating: string;
  fullscreenOptions = false;
  web360FrameClassName: string;
  modelRatingSubscription: Subscription;
  sceneChangeSubscription: Subscription;
  web360OptionsVisibilityChangeSubscription: Subscription;
  ratingsLoaded = true;
  @Input() optionsGridVisible = false;
  @Input() sceneNameVisible = false;

  constructor(public apiService: TourApiService,
              private goSurveyApiService: SurveyApiService,
              public tourService: TourService,
              public modalService: ModalService,
              public trackingService: TrackingService,
              public wishlistService: WishlistService,
              public optionDetailService: OptionDetailService) {}

  ngOnInit() {
    this.modelName = this.tourService.tour.modelInfo.modelName;
    this.currentScene = this.tourService.currentScene;
    // this.wishlistService.loadWishlist();

    if (this.tourService.tour.features.feedback.enabled) {
      this.ratingsLoaded = false;
    }

    if (this.goSurveyApiService.reviewsOverview) {
      this.modelRating = this.tourService.getStarsStringForRating(this.goSurveyApiService.reviewsOverview.mainRating.stars);
      this.ratingsLoaded = true;
    } else {
      this.modelRatingSubscription = this.goSurveyApiService.reviewsOverviewLoaded.subscribe(
        (loaded: boolean) => {
          if (loaded) {
            this.modelRating = this.tourService.getStarsStringForRating(this.goSurveyApiService.reviewsOverview.mainRating.stars);
          }
          this.ratingsLoaded = true;
        }
      );
    }

    this.sceneChangeSubscription = this.tourService.sceneChanged.subscribe(
      (updated: boolean) => {
        if (updated) {
          this.sceneNameVisible = false;
          this.optionsGridVisible = false;

          setTimeout(() => {
            this.currentScene = this.tourService.currentScene;
            this.sceneNameVisible = true;
            this.optionsGridVisible = (this.currentScene) ? this.currentScene.showOptions : false;
          }, 1000);
        }
      }
    );

    // set the available flag if we have a 360 tour
    if (this.tourService.tour.hasWeb360Tour()) {
      this.web360FrameClassName = 'web360';
      this.tourService.web360Available = true;

      // set the visible flag if we have no videos
      if (!this.tourService.videoAvailable) {
        this.tourService.web360Visibile = true;
      }

      // if there's options enable the nav bar options button
      if (this.tourService.web360Visibile && this.tourService.optionsAvailable) {
        this.tourService.web360OptionsButtonVisible = true;
      }

      this.web360OptionsVisibilityChangeSubscription = this.tourService.web360OptionsVisibilityChanged.subscribe(
        (visible: boolean) => {
          this.web360FrameClassName = (visible) ? 'web360-with-options' : 'web360';
        }
      );
    }

    // web360Visibile
    const page = this.tourService.web360Visibile ? this.tourService.tourFeatureTitle('3d') : this.tourService.tourFeatureTitle('tour');
    this.tourService.setDocumentTitleWithTour(page);
  }

  toggleOptions(icon: any) {
    this.fullscreenOptions = !this.fullscreenOptions;
    icon.innerHTML = this.fullscreenOptions ? 'arrow_downward' : 'arrow_upward';
    this.tourService.videoVisibilityChanged.emit(!this.fullscreenOptions);
  }

  toggleOptionsGroup(group: OptionGroup) {
    group.expanded = !group.expanded;
  }

  ngOnDestroy() {
    this.tourService.web360OptionsVisible = false;
    this.tourService.web360OptionsButtonVisible = false;
    this.sceneChangeSubscription.unsubscribe();
    if (this.modelRatingSubscription != null) {
      this.modelRatingSubscription.unsubscribe();
    }
    if (this.web360OptionsVisibilityChangeSubscription != null) {
      this.web360OptionsVisibilityChangeSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tour.component.ts